import { Link, useLocation } from '@tanstack/react-router';
import { Activity, LayoutDashboard, ShieldCheck, UserCircle, Users } from 'lucide-react';
import { useSession } from '../hooks/auth';

export default function MobileTabBar() {
  const location = useLocation();
  const { session, loading } = useSession();

  if (loading || !session) return null;

  const tabs = [
    {
      label: 'My Insights',
      icon: LayoutDashboard,
      to: '/my-insights' as const,
      show: true,
    },
    {
      label: 'Team',
      icon: Activity,
      to: '/team-insights' as const,
      show: !!session?.iselevated,
    },
    {
      label: 'CRM',
      icon: Users,
      to: '/crm' as const,
      show: !!(session?.iselevated && session?.isglobal),
    },
    {
      label: 'Admin',
      icon: ShieldCheck,
      to: '/admin' as const,
      show: !!(session?.iselevated && session?.isglobal),
    },
    {
      label: 'Profile',
      icon: UserCircle,
      to: '/profile' as const,
      show: true,
    },
  ].filter(tab => tab.show);

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 flex items-stretch border-t border-slate-700 bg-gradient-to-b from-slate-800 to-slate-900"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Mobile navigation"
    >
      {tabs.map(({ label, icon: Icon, to }) => {
        const isActive = location.pathname.startsWith(to);
        return (
          <Link
            key={to}
            to={to}
            className={`flex flex-1 flex-col items-center justify-center gap-1 py-3 text-xs transition-colors ${
              isActive ? 'text-blue-400' : 'text-neutral-400 hover:text-neutral-200'
            }`}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon size={22} strokeWidth={isActive ? 2 : 1.5} aria-hidden="true" />
            <span className="font-medium">{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
